// @flow

export async function MeetingPackageListApp() {
  return (await import('packages/show')).MeetingPackageListApp;
}

export async function CelebrationPackageListApp() {
  return (await import('packages/show')).CelebrationPackageListApp;
}

export async function ExperiencePackageListApp() {
  return (await import('packages/show')).ExperiencePackageListApp;
}

export async function VenuePackageListApp() {
  return (await import('packages/show')).VenuePackageListApp;
}

export async function ProfileEditRichTextEditor() {
  return (
    await import(
      'profiles/common/edit/components/ProfileEditRichTextEditor.rails'
    )
  ).default;
}

export async function InquiryFormFields() {
  return (await import('inquiry/components/InquiryFormFields')).default;
}

export async function AvailabilitySourceForm() {
  return (await import('reservations/components/AvailabilitySourceForm'))
    .default;
}

export async function EventConsultationRoot() {
  return (await import('eventConsultations')).default;
}

export async function PhoneNumberForm() {
  return (await import('phoneNumbers/components/PhoneNumberForm')).default;
}

export async function ViewPhoneNumberButton() {
  return (await import('phoneNumbers/components/ViewPhoneNumberButton.rails'))
    .default;
}

export async function SiblingGroupPreviewApp() {
  return (await import('groups/venues/show/components/SiblingGroupPreviewApp'))
    .default;
}

export async function SimilarVenueList() {
  return (
    await import(
      'profiles/venues/show/components/similarVenues/SimilarVenueList.rails'
    )
  ).default;
}

export async function Rating() {
  return (await import('common/components/Rating')).default;
}

export async function RatingBoxAccordion() {
  return (await import('common/components/accordion/RatingBoxAccordion'))
    .default;
}

export async function VenueInfoBoxAccordion() {
  return (await import('common/components/accordion/VenueInfoBoxAccordion'))
    .default;
}

export async function CommissionRoot() {
  return (await import('commission/components/CommissionRoot.rails')).default;
}

export async function PackageEditorRoot() {
  return (await import('packages/edit')).default;
}

export async function ConversationRoot() {
  return (await import('conversations/show/components/ConversationRoot.rails'))
    .default;
}

export async function CateringInquiryConversationApp() {
  return (
    await import(
      'conversations/show/components/CateringInquiryConversationApp.rails'
    )
  ).default;
}

export async function MarkAsRepliedRoot() {
  return (await import('conversations/show/components/MarkAsRepliedRoot.rails'))
    .default;
}

export async function VenueGroupEditorApp() {
  return (await import('groups/venues/edit')).default;
}

export async function TranslatedVenueDescription() {
  return (
    await import('profiles/venues/show/components/TranslatedVenueDescription')
  ).default;
}

export async function MoveToSearchLinks() {
  return (
    await import('profiles/venues/show/components/MoveToSearchLinks.rails')
  ).default;
}

export async function SendCopy() {
  return (await import('thanks/components/SendCopy')).default;
}

export async function MessageTemplateEditorApp() {
  return (
    await import('messageTemplates/components/MessageTemplateEditorApp.rails')
  ).default;
}

export async function MultiSelect() {
  return (await import('common/components/MultiSelect.rails')).default;
}

export async function VenuePageInquiryForm() {
  return (await import('inquiry/components/VenuePageInquiryForm.rails'))
    .default;
}

export async function SearchableInquiryIndex() {
  return (
    await import('conversations/index/components/SearchableInquiryIndex.rails')
  ).default;
}

export async function InvoicingFields() {
  return (
    await import('admin/invoicingFields/components/InvoicingFields.rails')
  ).default;
}

export async function PromotionBanner() {
  return (await import('profiles/venues/show/components/PromotionBanner'))
    .default;
}

export async function FeaturedEventTypeField() {
  return (
    await import('staff/featuredVenuesEdit/components/FeaturedEventTypeField')
  ).default;
}

export async function FeaturedVenuesInventory() {
  return (
    await import(
      'staff/featuredVenuesInventory/components/FeaturedVenuesInventory.rails'
    )
  ).default;
}

export async function EditOrganizationTabs() {
  return (await import('staff/organization/components/EditOrganizationTabs'))
    .default;
}

export async function OrganizationNotesFromCRM() {
  return (
    await import('staff/organization/components/OrganizationNotesFromCRM')
  ).default;
}

export async function ProfileAnnouncementsEditorApp() {
  return (
    await import(
      'staff/organization/components/ProfileAnnouncementsEditorApp.rails'
    )
  ).default;
}

export async function SearchWidgetPeopleInput() {
  return (await import('search/components/SearchWidgetPeopleInput')).default;
}

export async function CateringSearch() {
  return (await import('catering/search/components/CateringSearch.rails'))
    .default;
}

export async function CateringBasicInformation() {
  return (await import('profiles/catering/show/cateringComponents.rails'))
    .CateringBasicInformation;
}
export async function CateringDetailedInformation() {
  return (await import('profiles/catering/show/cateringComponents.rails'))
    .CateringDetailedInformation;
}
export async function CateringHeading() {
  return (await import('profiles/catering/show/cateringComponents.rails'))
    .CateringHeading;
}
export async function ProfileImageCarousel() {
  return (
    await import('profiles/common/show/components/ProfileImageCarousel.rails')
  ).default;
}
export async function CateringInquiry() {
  return (await import('profiles/catering/show/cateringComponents.rails'))
    .CateringInquiry;
}
export async function CateringServicesAndPricing() {
  return (await import('profiles/catering/show/cateringComponents.rails'))
    .CateringServicesAndPricing;
}
export async function CateringMenuList() {
  return (await import('profiles/catering/show/cateringComponents.rails'))
    .CateringMenuList;
}

export async function SupplierProfileServicesAndPricing() {
  return (
    await import(
      'profiles/suppliers/show/components/SupplierProfileServicesAndPricing.rails'
    )
  ).default;
}
export async function SupplierProfileHeading() {
  return (
    await import(
      'profiles/suppliers/show/components/SupplierProfileHeading.rails'
    )
  ).default;
}
export async function SupplierProfileInquiry() {
  return (
    await import(
      'profiles/suppliers/show/components/SupplierProfileInquiry.rails'
    )
  ).default;
}
export async function SupplierProfileBasicInformation() {
  return (
    await import(
      'profiles/suppliers/show/components/SupplierProfileBasicInformation.rails'
    )
  ).default;
}
